import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@tsin-env/environment';
import {
  CreateApplicationInput,
  CreateRefenceInput,
  IApplicationDTO,
  IApplicationNoteStep,
  IPoolInput,
  IReferences,
  IUploadAvatar,
  IUploadCoverLatter,
  IUploadDocs,
  IUserApplicationState,
  UpdateApplicationInput,
  UpdateReferenceInput,
} from './application.interface';
import { Observable } from 'rxjs';

const API_URI = `${environment.apiBaseUrl}/applications`;

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  http: HttpClient = inject(HttpClient);

  getApplications(queryParams?: { [key: string]: any }) {
    let params = new HttpParams();

    if (queryParams) {
      Object.keys(queryParams).forEach((key) => {
        const value = queryParams[key];
        if (value !== undefined && value !== null) {
          params = params.set(key, value.toString());
        }
      });
    }

    return this.http.get(API_URI, { params });
  }

  getUserApplications(id: string) {
    return this.http.get(API_URI + '/user-applications/' + id);
  }

  createApplication(input: CreateApplicationInput) {
    return this.http.post(API_URI, input);
  }

  applicationNote(input: IApplicationNoteStep): Observable<IApplicationDTO> {
    return this.http.patch<IApplicationDTO>(API_URI + `/application-note`, input);
  }

  referenceNote(input: { referenceId: string, note: string }): Observable<IReferences> {
    return this.http.patch<IReferences>(API_URI + `/reference-note`, input);
  }

  getSingle(id: string) {
    return this.http.get(API_URI + `/single/${id}`);
  }

  updateApplication(input: UpdateApplicationInput) {
    return this.http.post(API_URI, input);
  }

  delete(id: string) {
    return this.http.delete(API_URI + `/single/${id}`);
  }

  reviewStatus(input: { id: string; applicationReviewStatus: string }) {
    return this.http.patch(API_URI + '/application-review-status', input);
  }

  submitApplication(input: { id: string }) {
    return this.http.patch(API_URI + '/submit', input);
  }

  uploadAvatar(input: IUploadAvatar) {
    return this.http.post(API_URI + '/upload-avatar', input);
  }

  uploadResume(input: IUploadDocs) {
    return this.http.post(API_URI + '/upload-resume', input);
  }

  uploadCoverLetter(input: IUploadCoverLatter) {
    return this.http.post(API_URI + '/upload-cover-letter', input);
  }

  addToPool(input: IPoolInput) {
    return this.http.patch(API_URI + '/add-to-pool', input);
  }

  getPoolAppl(department: string) {
    return this.http.get(API_URI + '/all/' + department);
  }

  addReference(input: CreateRefenceInput) {
    return this.http.post(API_URI + '/references', input);
  }

  updateReference(input: UpdateReferenceInput) {
    return this.http.put(API_URI + '/references', input);
  }

  getApplicationReference(id: string) {
    return this.http.get(API_URI + `/references/${id}`);
  }

  deleteReference(id: string) {
    return this.http.delete(API_URI + `/references/${id}`);
  }
}
